import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentRouteName } from '@neptune/shared/routing-business-logic';

import { calculateSelectedTab } from './calculate-project-tab';

const projectSectionNameBySelectedTab = {
  runs: undefined,
  'model-registry': 'Models',
  metadata: 'Project metadata',
  trash: 'Trash',
  notebooks: 'Notebooks',
  reports: 'Reports',
  wiki: 'Wiki',
};

type ProjectSection = {
  id: string;
  displayName?: string;
};

export const useProjectSection = (): ProjectSection => {
  const currentRouteName = useSelector(getCurrentRouteName);

  const selectedTab = calculateSelectedTab(currentRouteName);

  const sectionName = selectedTab ? projectSectionNameBySelectedTab[selectedTab] : undefined;

  return React.useMemo(
    () => ({
      id: selectedTab as string,
      displayName: sectionName,
    }),
    [sectionName, selectedTab],
  );
};
